import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=c78b2af4&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c78b2af4')) {
      api.createRecord('c78b2af4', component.options)
    } else {
      api.reload('c78b2af4', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=c78b2af4&", function () {
      api.rerender('c78b2af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24LP8l758n1Kf/JS/comp/ErrorMessage.vue"
export default component.exports